import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestMotorGearPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#1F2A44]',
  COMMONS_FOOTER_BG: 'bg-[#1F2A44]',

  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#77ade7]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#1F2A44]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#1F2A44]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#77ade7]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#FF6F20] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#FF6F20] text-[#FF6F20] [&>svg>path]:stroke-[#FF6F20] [&>svg>g>path]:stroke-[#FF6F20] [&>svg>path]:fill-[#FF6F20] [&>svg>g>path]:fill-[#FF6F20]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#FF6F20]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#1F2A44]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#1F2A44]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-white',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#77ade7]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#1F2A44]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-white',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-white',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#1F2A44] [&>.explore-icon-fill]:!fill-[#1F2A44] [&>g>.explore-icon-fill]:!fill-[#1F2A44]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#1F2A44] [&>.vector-top>path]:fill-[#1F2A44] [&>.vector-bottom>path]:fill-[#1F2A44]',

  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#1F2A44]',
  HOMEPAGE_HEADER_BG: 'bg-[#1F2A44]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#1F2A44]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#1F2A44]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#1F2A44] text-[#1F2A44] [&>svg>path]:stroke-[#1F2A44] [&>svg>g>path]:stroke-[#1F2A44] [&>svg>path]:fill-[#1F2A44] [&>svg>g>path]:fill-[#1F2A44]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#1F2A44] text-[#1F2A44] [&>svg>path]:stroke-[#FF6F20] [&>svg>g>path]:stroke-[#FF6F20] [&>svg>path]:fill-[#FF6F20] [&>svg>g>path]:fill-[#FF6F20]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#1F2A44]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#1F2A44]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#1F2A44]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#1F2A44]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#1F2A44]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#4CAF50] [&>.vector-top>path]:fill-[#1F2A44] [&>.vector-bottom>path]:fill-[#1F2A44]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#4CAF50] [&>circle]:stroke-[#4CAF50] [&>path]:fill-[#1F2A44]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#FF6F20] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#FF6F20] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#FF6F20]',
  LISTPAGE_ANCHOR_LINK: 'text-[#FF6F20]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#FF6F20] [&_path]:fill-[#FF6F20] [&_path]:stroke-[#FF6F20]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#FF6F20]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#FF6F20]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#FF6F20]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#FF6F20]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#FF6F20]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#4CAF50]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#4CAF50]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#4CAF50]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#4CAF50]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#4CAF50]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#4CAF50]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#77ade7]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#77ade7] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#77ade7]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#77ade7]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#77ade7]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
}
